// Patients list + patient detail (clinical record) strings.
const strings = {
  es: {
    edit_patient: "Editar paciente",
    pt_search_ph: "Buscar por nombre, expediente, CURP o teléfono…",
    pt_empty: "Aún no hay pacientes",
    pt_empty_hint: "Registra al primer paciente para abrir su expediente clínico.",
    pt_no_match: "Ningún paciente coincide con la búsqueda",
    pt_no_match_hint: "Prueba con otro nombre, expediente, CURP o teléfono, o cambia los filtros.",
    pt_clear_filters: "Limpiar filtros",
    pt_filter_doctor: "Médico",
    pt_filter_doctor_all: "Médico: todos",
    pt_filter_unassigned: "Sin asignar",
    pt_filter_clinic: "Clínica",
    pt_filter_clinic_all: "Clínica: todas",
    pt_reassign: "Reasignar",
    pt_count: "{n} pacientes",
    pt_sec_general: "Datos generales",
    pt_sec_contact: "Contacto",
    pt_sec_background: "Antecedentes",
    pt_curp_invalid: "CURP inválida: deben ser 18 caracteres (ej. GODE561231HDFRRN09)",
    pt_email_invalid: "Correo electrónico inválido",
    pt_name_required: "El nombre es obligatorio",
    pt_treating_doctor: "Médico tratante",
    pt_doctor_required: "Selecciona el médico tratante",
    pt_choose_doctor: "Selecciona un médico…",
    pt_no_doctors_assigned: "No tienes médicos asignados. Pide a la clínica que te asigne uno.",
    pt_doctor_optional_hint: "Opcional: puedes asignarlo después.",
    pt_not_found: "Paciente no encontrado o sin acceso",
    pt_not_found_hint: "Es posible que el paciente se haya eliminado o que no esté asignado a ti.",
    pt_back_to_list: "Volver a pacientes",
    pt_allergies_label: "Alergias: {list}",
    pt_no_allergies: "Sin alergias registradas",
    pt_book: "Agendar cita",
    pt_appointments_empty: "Este paciente no tiene citas registradas",
    pt_appointments_load_error: "No se pudieron cargar las citas",
    pt_upcoming: "Próximas",
    pt_past: "Anteriores",
    pt_reason_none: "Sin motivo",
    pt_assistant_note: "El expediente clínico solo es visible para el personal clínico.",
    pt_demographics: "Datos del paciente",
    pt_rec_empty_error: "Escribe el padecimiento actual o los diagnósticos antes de guardar.",
    pt_ai_inserts_into: "Se insertará en Indicación terapéutica",
    pt_ai_inserts_into_rx: "Se insertará en Indicaciones",
    pt_signed_locked: "Las notas firmadas no se pueden modificar (NOM-004).",
    pt_older_records: "Notas anteriores ({n})",
    pt_rx_desc: "{name} · {age} · {weight}",
    pt_rx_meds_error: "Completa todos los datos obligatorios de cada medicamento.",
    pt_rx_generic: "Denominación genérica",
    pt_rx_brand: "Denominación distintiva (marca)",
    pt_rx_presentation: "Presentación comercial",
    pt_rx_presentation_hint: "Concentración, contenido y forma farmacéutica. Ej. 500 mg, caja con 20 tabletas.",
    pt_rx_duration: "Duración del tratamiento",
    pt_rx_qty: "Cantidad a surtir",
    pt_rx_qty_short: "Surtir",
    pt_rx_dose_ph: "Ej. 1 tableta",
    pt_rx_freq_ph: "Ej. cada 8 horas",
    pt_rx_duration_ph: "Ej. 7 días",
    pt_rx_qty_ph: "Ej. 1 caja",
    pt_rx_controlled: "Medicamento controlado (Fracción III)",
    pt_rx_controlled_hint: "La receta indicará que puede surtirse hasta 3 veces y que la farmacia la retiene después del tercer surtimiento.",
    pt_rx_controlled_badge: "Controlado · Fr. III",
    pt_rx_institution: "institución que otorgó el título",
    pt_rx_prescriber_missing: "A tu perfil le falta: {fields}. La receta impresa debe incluirlos.",
    pt_rx_complete_profile: "Completar perfil",
    pt_rx_dob_missing: "El paciente no tiene fecha de nacimiento registrada; la receta debe incluirla junto con su edad. Agrégala en Datos → Editar.",
    pt_remove_med: "Quitar medicamento",
    pt_med_n: "Medicamento {n}",
    pt_weight_unknown: "peso sin registrar",
    pt_age_unknown: "edad sin registrar",
    pt_close: "Cerrar",
    pt_delete_att_q: "¿Eliminar archivo?",
    pt_delete_att_desc: "Se eliminará «{name}» del expediente. Esta acción no se puede deshacer.",
    pt_att_deleted: "Archivo eliminado",
    pt_download_error: "No se pudo descargar el archivo",
    pt_preview_error: "No se pudo abrir la vista previa",
    pt_tab_info: "Datos",
    pt_tab_appointments: "Citas",
    pt_tab_records: "Notas",
    pt_tab_rx: "Recetas",
    pt_tab_files: "Archivos",
    pt_age_years: "{n} años",
  },
  en: {
    edit_patient: "Edit patient",
    pt_search_ph: "Search by name, file number, CURP or phone…",
    pt_empty: "No patients yet",
    pt_empty_hint: "Register the first patient to open their medical record.",
    pt_no_match: "No patients match your search",
    pt_no_match_hint: "Try another name, file number, CURP or phone, or change the filters.",
    pt_clear_filters: "Clear filters",
    pt_filter_doctor: "Doctor",
    pt_filter_doctor_all: "Doctor: all",
    pt_filter_unassigned: "Unassigned",
    pt_filter_clinic: "Clinic",
    pt_filter_clinic_all: "Clinic: all",
    pt_reassign: "Reassign",
    pt_count: "{n} patients",
    pt_sec_general: "General information",
    pt_sec_contact: "Contact",
    pt_sec_background: "Medical history",
    pt_curp_invalid: "Invalid CURP: it must have 18 characters (e.g. GODE561231HDFRRN09)",
    pt_email_invalid: "Invalid email address",
    pt_name_required: "Name is required",
    pt_treating_doctor: "Treating doctor",
    pt_doctor_required: "Select the treating doctor",
    pt_choose_doctor: "Select a doctor…",
    pt_no_doctors_assigned: "You have no assigned doctors. Ask the clinic to assign you one.",
    pt_doctor_optional_hint: "Optional: you can assign one later.",
    pt_not_found: "Patient not found or no access",
    pt_not_found_hint: "The patient may have been deleted or is not assigned to you.",
    pt_back_to_list: "Back to patients",
    pt_allergies_label: "Allergies: {list}",
    pt_no_allergies: "No known allergies recorded",
    pt_book: "Book appointment",
    pt_appointments_empty: "This patient has no appointments",
    pt_appointments_load_error: "Couldn't load appointments",
    pt_upcoming: "Upcoming",
    pt_past: "Past",
    pt_reason_none: "No reason given",
    pt_assistant_note: "The clinical record is only visible to clinical staff.",
    pt_demographics: "Patient details",
    pt_rec_empty_error: "Enter the current illness or the diagnoses before saving.",
    pt_ai_inserts_into: "Will be inserted into Therapeutic indication",
    pt_ai_inserts_into_rx: "Will be inserted into Instructions",
    pt_signed_locked: "Signed notes cannot be modified (NOM-004).",
    pt_older_records: "Earlier notes ({n})",
    pt_rx_desc: "{name} · {age} · {weight}",
    pt_rx_meds_error: "Fill in every required field for each medication.",
    pt_rx_generic: "Generic name",
    pt_rx_brand: "Brand name",
    pt_rx_presentation: "Commercial presentation",
    pt_rx_presentation_hint: "Strength, contents and dosage form. E.g. 500 mg, box of 20 tablets.",
    pt_rx_duration: "Treatment duration",
    pt_rx_qty: "Quantity to dispense",
    pt_rx_qty_short: "Dispense",
    pt_rx_dose_ph: "E.g. 1 tablet",
    pt_rx_freq_ph: "E.g. every 8 hours",
    pt_rx_duration_ph: "E.g. 7 days",
    pt_rx_qty_ph: "E.g. 1 box",
    pt_rx_controlled: "Controlled medication (Fracción III)",
    pt_rx_controlled_hint: "The prescription will state it can be filled up to 3 times and that the pharmacy keeps it after the third fill.",
    pt_rx_controlled_badge: "Controlled · Fr. III",
    pt_rx_institution: "degree-granting institution",
    pt_rx_prescriber_missing: "Your profile is missing: {fields}. The printed prescription must include them.",
    pt_rx_complete_profile: "Complete profile",
    pt_rx_dob_missing: "This patient has no birth date on file; the prescription must show it along with their age. Add it under Details → Edit.",
    pt_remove_med: "Remove medication",
    pt_med_n: "Medication {n}",
    pt_weight_unknown: "weight not recorded",
    pt_age_unknown: "age not recorded",
    pt_close: "Close",
    pt_delete_att_q: "Delete file?",
    pt_delete_att_desc: "“{name}” will be removed from the record. This can't be undone.",
    pt_att_deleted: "File deleted",
    pt_download_error: "Couldn't download the file",
    pt_preview_error: "Couldn't open the preview",
    pt_tab_info: "Details",
    pt_tab_appointments: "Appointments",
    pt_tab_records: "Notes",
    pt_tab_rx: "Prescriptions",
    pt_tab_files: "Files",
    pt_age_years: "{n} years",
  },
};

export default strings;
